<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row align="center" justify="center">
        <v-col>
          <h3>
            <v-icon large>mdi-city-variant-outline</v-icon> Editar Endereço -
            {{ $route.params.id }}
          </h3>
        </v-col>
        <v-col cols="2" class="text-right">
          <TheButton text="Voltar" icon="mdi-chevron-left" color="blue" @click="back()" />
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-5 mb-5 elevation-hb" v-if="seller">
      <v-row>
        <v-col cols="6">
          <TheInput v-model="seller.address" label="Endereço" />
        </v-col>
        <v-col>
          <TheInput v-model="seller.number" label="Número" />
        </v-col>
        <v-col cols="3">
          <TheInput v-model="seller.cep" label="Cep" mask="#####-###" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TheInput v-model="seller.neighborhood" label="Bairro" />
        </v-col>
        <v-col>
          <TheInput v-model="seller.city" label="Cidade" />
        </v-col>
        <v-col>
          <TheInput v-model="seller.state" label="Estado" />
        </v-col>
        <v-col>
          <TheInput v-model="seller.complemment" label="Complemento" />
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <TheButton text="Salvar" icon="mdi-content-save" color="green" @click="saveSeller()" />
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

import TheInput from '@/components/TheInput'
import TheButton from '@/components/TheButton'

export default {
  name: 'SellersAddress',
  components: {
    TheInput,
    TheButton,
  },
  data: () => ({
    seller: {},
    loading: false,
  }),
  methods: {
    loadSeller() {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/seller/${id}`
      axios
        .get(url)
        .then((res) => {
          this.seller = res.data
        })
        .catch(showError)
    },
    saveSeller() {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/seller/${id}`
      axios
        .put(url, this.seller)
        .then((res) => {
          this.$router.push({ name: 'sellers' })
        })
        .catch(showError)
    },
    back() {
      this.$router.go(-1)
    },
  },
  created() {
    this.loadSeller()
  },
}
</script>

<style></style>
